import { OvertimeRule, OvertimeRuleCreate } from "./@types/OvertimeRuleModel";

export class OvertimeRepository {
    private httpService: IHttpService;
    constructor(instance: IHttpService) {
        this.httpService = instance;
    }
    async getOvertimes(): Promise<OvertimeRule[]> {
        try {
            const response = await this.httpService.get<TKResponse<OvertimeRule[]>>('/overtime_rules');
            return response.data
                .map((overtime: OvertimeRule) => ({ ...overtime, id: overtime.overtime_rule_id }))
                .sort((a, b) => (a.name.localeCompare(b.name)));
        } catch (error) {
            console.error('Error al obtener las overtime_rules:', error);
            throw error;
        }
    }
    async getById(id: number): Promise<OvertimeRule> {
        try {
            const response = await this.httpService.get<TKResponse<OvertimeRule>>(`/overtime_rules/${id}`);
            return response.data;
        }
        catch (error) {
            console.error(`Error al obtener el overtime_rule con ID ${id}:`, error);
            throw error;
        }
    }

    async createOvertime(overtime: OvertimeRuleCreate): Promise<OvertimeRule> {
        try {
            const response = await this.httpService.post<OvertimeRule, OvertimeRuleCreate>('/overtime_rules', { data: overtime });
            return response;
        } catch (error) {
            console.error('Error al crear el overtime_rules:', error);
            throw error;
        }
    }
    async deleteOvertime(id: number): Promise<number> {
        try {
            await this.httpService.delete<void>(`/overtime_rules/${id}`);
            return id;
        } catch (error) {
            console.error('Error deleteOvertimeRules:', error);
            throw error;
        }
    }
    async updateOvertime(OvertimeRules: OvertimeRule): Promise<OvertimeRule> {
        try {
            const response = await this.httpService.patch<OvertimeRule, OvertimeRule>(`/overtime_rules/${OvertimeRules.overtime_rule_id}`, { data: OvertimeRules });
            return response;
        } catch (error) {
            console.error('Error al actualizar el OvertimeRules:', error);
            throw error;
        }
    }
}
